<template>
	<div id="forgetPassword">
		<!-- <router-view></router-view> -->
		<div class="container">
			<!-- <div class="loginContainer">
				<img src="https://new-shengxue985-test.oss-cn-hangzhou.aliyuncs.com/sxzx/2021/3/pic/2a3c50f1382f4e958b7785df8ca47599.png"
					alt="" />
				<div class="right">
					<div class="iptContainer">
						<div class="title">
							登录
						</div>
						<el-input v-model="account" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
						<el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
							style="margin-bottom: 50px;"></el-input>
						<div class="btn" @click="login">
							登录
						</div>
					</div>
				</div>
			</div> -->

			<div class="left" :style="'background-size:'+833*ratio+'px '+900*ratio+'px'+';'">
			    <!-- <img src="../img/loginLeft.png" alt="" /> -->
			    <div class="guide-unit-wrapper">
			        <div class="guide-unit" :style="'transform: scale('+ratio+');'">
			            <div class="guide-title flex-h">
			                <img style="width:26px;height: 26px;" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/duidui11.png" />
			                <span class="flex1">活动举办单位</span>
			            </div>
			            <div class="guide-content">
			                <div class="guide-item">
			                    <span class="guide-label" style="font-weight: 600;">片区牵头高校：</span><span class="guide-text">在汉教育部直属高校毕业研究生就业工作协作组、武汉大学、北京航空航天大学、南京大学、哈尔滨工业大学、西安交通大学、中山大学。</span>
			                </div>
			                <div class="guide-item">
			                    <span class="guide-label" style="font-weight: 600;">各省牵头高校：</span> <span class="guide-text">吉林大学、大连理工大学、东北大学、南开大学、天津大学、山东大学、厦门大学、兰州大学、华南理工大学、湖南大学、郑州大学、合肥工业大学、河北工业大学、太原理工大学、南昌大学、云南大学、贵州大学、西南石油大学、内蒙古大学、海南大学。</span>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="right" >
				<div class="loginContainer1" :style="'transform: scale('+ratio+');'">
					<!-- <div class="switchover">
						<div class="" @click="changeLoginWay">切换为{{ isQrcode ? '账号密码' : '微信扫码' }}登陆</div>
						<img src="../img/qrCode.png" alt="" @click="changeLoginWay" />
					</div> -->
					<div class="logoContainer" style="transform: translateY(15px);">
					    <img :style="'transform: scale('+1+');'"  src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/02/xxxxx11111.png"
					        alt="" />
					
					</div>
					<div class="loginType">
						<!-- <div class="item" style="opacity: 0;">
							<div class="item1" :style="!isQrcode?'font-weight: bold;':''" >
								账号登录
							</div>
							<div class="xian1" v-if="!isQrcode">

							</div>
						</div> -->
						<div class="item">
							<div class="item1" :style="isQrcode?'font-weight: bold;':''" @click="chnageType2">
								找回密码
							</div>
							<!-- <div class="xian1" v-if="isQrcode">

							</div> -->
						</div>
					</div>

					<template v-if="isQrcode">
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImg">
									<div class="qrcode1" v-if="qrcodeImg">
										<img class="qrcode1" :src="qrcodeImg" alt="" />
									</div>
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
									
									<div class="refresh" v-if="count>120" @click="refreshQrcode()">
										<i class="el-icon-refresh-left"></i>
										<div class="">
											点击刷新
										</div>
									</div>
									<div class="scanSuccessful" v-if="isScanSuccessful&&count <= 120">
											<img src="../img/scanSuccessful.png"/>
										<div class="">
											扫码成功
										</div>
									</div>
								</div>
								<template v-if="isScanSuccessful&&count <= 120">
									<div class="hite2" style="margin-bottom: 10px;font-weight: 600;">请在手机上授权登录平台</span>
									</div>
									<div class="hite2" style="font-family: PingFang SC;color: #0084ff;cursor: pointer;" @click="reload">
										重新扫码
										</div>
								</template>
								<template v-else>
								<div class="hite1">打开<span style="color: #0084ff">微信扫一扫</span></div>
								<div class="hite2">找回密码</div>
								</template>
							</div>
						</div>
					</template>

					<template v-else>
						<div class="iptContainer">
							<div class="ipt" style="margin-bottom: 25px">
								<img src="../img/account.png" alt="" />
								<el-input v-model="account" placeholder="请输入您的手机号" @input='phone'></el-input>
							</div>
							<div class="ipt">
								<img src="../img/password.png" alt="" />
								<el-input v-model="password" placeholder="请输入您的密码" show-password></el-input>
							</div>
						</div>

						<div class="moreOpt">
							<div class="register" style="color: red;cursor: initial;">{{loginMsg}}</div>
						</div>

						<div class="moreOpt">
							<div class="register" @click="chnageType2">没有账号？点击注册</div>
							<div class="forgetPassword" @click="toRegister">忘记密码</div>
						</div>

						<div class="btn" @click="loginHr" :loading="true">登录</div>

						<div class="agreement" style="margin-bottom: 61px;">
							<el-checkbox v-model="checked" style="margin-right: 5px"
								@click="selectAgreement"></el-checkbox>
							<span @click="selectAgreement">请阅读并同意</span>
							<!-- <span style="color: #0084ff" @click="">《用户协议》</span> -->
							<span style="color: #0084ff" @click="toAgreement">《隐私协议》</span>
						</div>


					</template>

				</div>
			</div>
		</div>



		<div class="changePassword">
			<el-dialog title="找回密码" :visible.sync="changeDialogVisible" @close='elDialogClose1' :close-on-click-modal='false' width="500px">
				<div class="elDialogContainer">
					<div class="ipt" style="margin-bottom: 20px;background: #F5F7FA;">
						<div class="text">
							手机号
						</div>
						<el-input v-model="tel" disabled placeholder="请输入手机号"></el-input>
					</div>
					<!-- <div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							旧密码
						</div>
						<el-input type="password" v-model="oldPassword" placeholder="请输入旧密码"></el-input>
					</div> -->
					<div class="ipt" style="margin-bottom: 20px;align-items: baseline;">
						<div class="text">
							新密码
						</div>
						<el-input type="password" autocomplete="new-password" show-password v-model="password" placeholder="请输入新密码（不少于4位数）"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							确认新密码
						</div>
						<el-input type="password" autocomplete="new-password" show-password v-model="repetitionPassword" placeholder="请再次输入新密码"></el-input>
					</div>

				</div>
				<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="primary" @click="submit2">确认</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapActions
	} from 'vuex'
    const config = require('../../WebConfig')
	// import { getMeetList, getQrcode, loginByScene } from '@/api/studentv2.js'
	export default {
		beforeRouteLeave(to, from, next) {
			// 这里可以添加离开当前路由前的逻辑，例如在离开前保存数据等
			clearInterval(this.intervalId)
			next(); // 确保调用next()来继续路由跳转
		},
		data() {
			return {
				qrcodeImg: '',
				account: '',
				password: '',
				sceneId: '',
				checked: false,

				isQrcode: true,
				intervalId: null,
				isForget: 0,


				count: 0,

				loginMsg: '',

				tel: '',
				changeDialogVisible: false,

				oldPassword: '',
				repetitionPassword: '',
				
				ratio:0,
				isScanSuccessful:false
			}
		},
		// destroyed() {
		// 	clearInterval(this.intervalId)
		// 	
		// },

		async mounted() {
			clearInterval(this.intervalId)
			window.removeEventListener('resize', this.handleResize)
			this.handleResize()
			window.addEventListener('resize', this.handleResize);
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			//
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			// this.getMeetList()
			// this.qrcodeImg = localStorage.getItem('qrcodeImg') || ''
			await this.getQrcode()
			this.setTimer()
			// this.loginByScene()
		},
		beforeDestory() {
			clearInterval(this.intervalId)
		},
		methods: {
			...mapActions(['getCompanyUserInfo']),
			...mapMutations(['setToken', 'setUserInfo', 'setSchoolData', 'setUserId', 'setAdminId']),
			async reload(){
				if (this.isRequest()) return false
				clearInterval(this.intervalId)
				this.count = 0
				await this.getQrcode()
				this.isScanSuccessful = false
				this.setTimer()
			},
			handleResize(){
				console.log( window.innerHeight)
				if(window.innerHeight>600){
					this.ratio = parseFloat(window.innerHeight/919)
				}else{
					this.ratio = 0.65
				}
			},
			async elDialogClose1() {
				this.changeDialogVisible = false
				clearInterval(this.intervalId)
				this.count = 0
				await this.getQrcode()
				this.isScanSuccessful = false
				this.setTimer()
			},
			submit2() {
				clearInterval(this.intervalId)
				if (this.isRequest()) return false
				// if (this.oldPassword == '') {
				// 	this.$message.error('请输入旧密码');
				// 	return
				// }
				if (this.password == '') {
					this.$message.error('请输入新密码');
					return
				}
        console.log("aaa",this.password.length)
        if (this.password.length < 4) {
					this.$message.error('密码长度不能小于4位');
					return
				}
				if (this.password != this.repetitionPassword) {
					this.$message.error('两次密码不一致');
					return
				}

				this.$util.post(
					"v2/school_job/modify_pass", {
						tel: this.tel,
						password: this.password,
					},
					(res) => {
						if (res.code == 0) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.changeDialogVisible = false

							setTimeout(() => {
								this.$router.push({
									path: '/login',
								})
							}, 2000)

						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			toAgreement() {
				// this.$router.push({
				// 	path: '/privacy',
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// })
				window.open('https://np-admin.sx985.com/xz/index.html#/privacy', '_blank')
			},
			login() {
				this.setIslogin(true)
				this.$router.push({
					path: '/',
					// query: {
					//   id: 1,
					// },
				})
			},
			phone() {
				this.account = this.account.replace(/\D/g, '')
			},
			// 防抖处理
			isRequest(duration = 2000) {
				if (this.request) return true;
				this.request = true;
				setTimeout(() => {
					this.request = false;
				}, duration)
				return false;
			},
			refreshQrcode() {
				if (this.isRequest()) return false;
				this.count = 0
				this.setTimer()
			},
			loginHr() {
				if (this.isRequest()) return false;
				clearInterval(this.intervalId)
				if (!this.account) {
					this.$message.error('请输入手机号码')
					return
				}
				if (!this.password) {
					this.$message.error('请输入账号密码')
					return
				}
				if (!this.checked) {
					this.$message.error('请认真阅读并同意隐私协议')
					return
				}
				let obj = {
					tel: this.account,
					password: this.password,
				}

				this.$util.post(
					"v2/school_job/login_hr", {
						...obj
					},
					(res) => {
						if (res.code === 200) {
							// this.$message({
							// 	message: '登录成功',
							// 	type: 'success',
							// 	duration: 1000
							// });
							// this.$message.success("登录成功")


							if (res.data.status === 0) {
								this.$alert('抱歉，您的账号已被贵司超级管理员注销，请联系管理员开启账号权限！', '标题', {
									confirmButtonText: '确定',
									callback: () => {

									}
								});
							} else {
								this.getCompanyInfo(res.data.admin_id)
								this.setUserInfo(res.data)
								this.setUserId(res.data.user_id)
								this.setAdminId(res.data.admin_id)
								setTimeout(() => {
									this.$router.push({
										path: '/home',
									})
								}, 1000)
							}


						} else if (res.code == -1) {
							// this.isQrcode = true

							if (res.msg == '账号不存在') {
								this.$message.error(res.msg + '请前往注册')
								this.isQrcode = true
								this.loginMsg = '账号不存在请注册'
							} else {
								this.$message.error(res.msg)
								this.loginMsg = res.msg
							}
							// this.setTimer()
						} else {
							this.$message.error(res.msg)
							this.setTimer()
							this.loginMsg = res.msg
						}
					}
				);


				// loginHr(obj).then((res) => {
				// 	
				// 	if (res.code === 200) {
				// 		this.$message.success("登录成功")

				// 		this.getCompanyInfo(res.data.admin_id)
				// 		setTimeout(() => {
				// 			this.$router.push({
				// 				path: '/home',
				// 			})
				// 		}, 200)
				// 	} else {
				// 		this.$message.error(res.msg)
				// 	}

				// })
			},
			setTimer() {
				this.intervalId = setInterval(() => {
					if(this.isScanSuccessful){
						this.loginByScene()
					}else{
						this.loginByScene2()
					}
					if (this.count > 120) {
						clearInterval(this.intervalId)
					} else {
						this.count += 2
					}
				}, 2000)
			},
			getCompanyInfo(adminId) {
				if (!adminId) {
					return
				}
				this.$util.post(
					"v2/school_job/getCompanyInfo", {
						admin_id: adminId,
					},
					(res) => {
						if (res.code === 200) {
							if (res.data.job_title && res.data.job_title[0]) {
								// localStorage.setItem('job_title', JSON.stringify(res.data.job_title))
								// this.jobs = {
								// 	job_title: JSON.stringify(res.data.job_title),
								// }
							} else {
								localStorage.setItem('job_title', '')
							}
							// this.$store.commit('setSchoolData', res.data)
							this.setSchoolData(res.data)
							// localStorage.setItem('schoolData', JSON.stringify(res.data))
						}

					}
				);
				//   getCompanyInfo(adminId).then((res) => {
				//     if (res.code === 200) {
				//       if (res.data.job_title && res.data.job_title[0]) {
				//         localStorage.setItem('job_title', JSON.stringify(res.data.job_title))
				//         this.jobs = {
				//           job_title: JSON.stringify(res.data.job_title),
				//         }
				//       } else {
				//         localStorage.setItem('job_title', '')
				//       }

				//       this.$store.commit('setSchoolData', res.data)
				//       localStorage.setItem('schoolData', JSON.stringify(res.data))
				//     }
				//   })
			},
			loginByScene2(){
				this.$util.post(
					'api/student/login_by_scene2', {
						scene: this.sceneId,
						not_login:1
					},
					(resx) => {
						console.log(resx)
						if(resx.code==0){
							if(resx.data.register == 2){
								this.isScanSuccessful = true
								
							}
						}
					}
				)
			},
			loginByScene() {
				if (!this.sceneId) {
					clearInterval(this.intervalId)
					return
				}
				this.$util.post(
					"api/student/login_by_scene", {
						scene: this.sceneId,
						// scene: this.sceneId,
					},
					(responce) => {
						if (responce.code == 0) {
							clearInterval(this.intervalId)
							this.tel = responce.data.user_info.tel
							this.changeDialogVisible = true
						}
					}
				);
				// loginByScene(this.sceneId).then((responce) => {

				// })
			},
			getQrcode() {
				return new Promise((resolve, reject) => {
				this.$util.post(
					"admin/home/qrcode", {
						app_type: 10,
						page_path: 'pages/login/login',
						is_test:0 ,
                        // config.IS_TEST
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							this.sceneId = res.data.scene
							// this.setTimer()
							localStorage.setItem('qrcodeImg', res.data.qrCode)
							resolve()
						}else{
							resolve()
						}
					}
				);
				})
			},
			// getQrcode().then((res) => {
			// 	if (res.code == 200) {
			// 		this.qrcodeImg = res.data.qrCode
			// 		this.sceneId = res.data.scene

			// 		this.setTimer()
			// 		localStorage.setItem('qrcodeImg', res.data.qrCode)
			// 	}
			// })
			// getMeetList(){
			//       	let obj = {
			//       		page:1,
			//       	}
			//         //   if(this.headIndex){
			//         //       obj.meeting_type =this.headIndex
			//         //   }
			//       	// if(this.tapIndex!=0){
			//       	// 		obj.meeting_status = this.tapIndex
			//       	// }
			//       	getMeetList(obj).then(res => {
			//       	    if (res.code === 200) {

			//       	    }
			//       	})
			//       },
			toRegister() {
				if (this.isRequest()) return false;
				this.isQrcode = true
				this.qrcodeTxt = '注册'
				this.isForget = 1
				this.setTimer()
				// this.setTimer()
			},
			changeLoginWay() {
				// clearInterval(this.intervalId)
				this.isQrcode = !this.isQrcode
				this.qrcodeTxt = '登录/注册'
				this.isForget = 0
				// if (!this.isQrcode) {
				// 	clearInterval(this.intervalId)
				// } else {
				// 	this.setTimer()
				// }
			},
			chnageType1() {
				clearInterval(this.intervalId)
				this.isQrcode = false
				
			},
			chnageType2() {
				if (this.isRequest()) return false;
				this.count = 0
				this.setTimer()
				// this.qrcodeTxt = '登录/注册'
				this.isForget = 0
				this.isQrcode = true
				
			},

			selectAgreement() {
				this.checked = !this.checked
			},
		},
		components: {},
	}
</script>
<style>
	/* #forgetPassword .el-input__inner {
		border: none;
		background: #eaf4fe;
		font-size: 18px;
	} */

	/* 设置所有input元素的placeholder文本颜色为灰色 */
	/* #forgetPassword input::placeholder {
		color: #656565;
	} */

	#forgetPassword .el-checkbox__inner {
		/* border-radius: 50%; */
		border: 1px solid #0084ff;
	}


	.changePassword .el-input__inner {
		border: none !important;
		text-align: right !important;
		background: initial !important;
		/* font-size: 16px !important; */
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 180px;
		min-height: 400px;
	}

	#forgetPassword .el-menu {
		background: #225ac4;
	}

	#forgetPassword .el-menu-item span {
		color: #ffffff;
	}

	#forgetPassword .el-menu-item:focus,
	.el-menu-item:hover {
		outline: 0;

	}

	#forgetPassword .el-menu-item.is-active {
		color: #225ac4;
		background-color: rgba(27, 72, 157) !important;
	}

	#forgetPassword .el-menu-item.is-active span {
		color: #90c1ff;
	}

	.changePassword .el-input__inner {
		border: none !important;
		text-align: right !important;
		background: initial !important;
		/* font-size: 16px !important; */
	}
	#forgetPassword .el-dialog{
		margin: 200px auto 50px !important;
	}
</style>
<style lang="less" scoped>
	#forgetPassword {}

	.container {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		background: #dfeafe;
		// justify-content: center;
		// background: url(https://new-shengxue985-test.oss-cn-hangzhou.aliyuncs.com/sxzx/2021/3/pic/16c3b44183f34011a10909b690f1869a.png);

	}

	.left {
	    min-width: 600px;
	    width: 50%;
	    font-size: 0;
	    height: 100vh;
	    background: url(https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/31/oooi1111.png);
	    background-repeat: no-repeat;
	    // background-size: 739px 800px;
	    background-position:top center;
	    position: relative;
	    transform: translateY(-24px);
	
	    .guide-unit-wrapper {
	        position: absolute;
	        left: 50%;
	        bottom: 30px;
	        transform: translateX(-50%);
	        width: 100%;
	        display: flex;
	        justify-content: center;
	    }
	
	    .guide-unit {
	        max-width: 700px;
	        width: 100%;
	        padding: 15px 20px;
	        // background: rgba(255, 255, 255, 0.9);
	        // border: 1px solid #e0e0e0;
	        border-radius: 8px;
	        transform-origin: bottom center;
	        .guide-title {
	            display: flex;
	            align-items: center;
	            font-weight: bold;
	            font-size: 14px;
	            color: #333;
	            margin-bottom: 10px;
	            margin-left: -3px;
	
	            i {
	                color: #1e40af;
	                margin-right: 8px;
	                font-size: 16px;
	            }
	        }
	
	        .guide-content {
	            .guide-item {
	                font-size: 12px;
	                color: #666;
	                line-height: 1.6;
	                margin-bottom: 8px;
	
	                &:last-child {
	                    margin-bottom: 0;
	                }
	            }
	            span{
	                // font-size:14px;
	            }
	            .guide-label {
	                color: #333;
	                font-weight: 500;
	                // display: inline-block;
	                vertical-align: top;
	            }
	
	            .guide-text {
	                // display: inline-block;
	                vertical-align: top;
	                word-break: break-all;
	                color:#000000;
	                opacity: 0.8;
	            }
	        }
	    }
	}

	.right {
		width: 50%;
		min-width: 600px;
		background: #f7faff;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loginContainer {
		display: flex;
		font-size: 0;

		// .right {
		// 	width: 600px;
		// 	height: 640px;
		// 	background: #fff;
		// 	border-radius: 0 16rpx 16rpx 0;
		// 	display: flex;
		// 	// align-items: center;
		// 	justify-content: center;
		// 	background: #fff;
		.iptContainer {
			padding-top: 100px;

			.title {
				font-size: 28px;
				font-weight: bold;
				color: #0a2145;
				margin-bottom: 100px;
			}

			.el-input {
				margin-bottom: 25px;
			}

			.btn {
				width: 100%;
				height: 40px;
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #fff;
				background: #0c66ff;
				border-radius: 8px;
			}
		}

		// }
	}

	.loginContainer1 {
		width: 510px;
		display: flex;
		align-items: center;
		flex-direction: column;
		// height: 695px;
		// border-radius: 10px;
		// box-shadow: 0px 4px 57px 8px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
		padding: 25px 25px;
		background: #f7faff;

		.switchover {
			display: flex;
			font-size: 0;
			justify-content: flex-end;

			div {
				height: min-content;
				padding: 5px 18px;
				background: #f5f9ff;
				font-weight: 400;
				font-size: 18px;
				color: #0084ff;
				border-radius: 2px;
				margin-right: 2px;
			}

			img {
				width: 85px;
				height: 85px;
			}
		}

		.logoContainer {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 0;
			margin-bottom: 50px;

			img {
				width: 362px;
				height: 43px;
				// margin-right: 20px;
			}
		}

		.iptContainer {
			margin-bottom: 25px;

			.ipt {
				width: 460px;
				padding: 15px 10px;
				box-sizing: border-box;
				background: #eaf4fe;
				border-radius: 10px;
				display: flex;
				align-items: center;

				img {
					width: 30px;
					height: 30px;
					margin-right: 10px;
				}
			}
		}

		.moreOpt {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 25px;

			.forgetPassword {
				font-weight: 500;
				font-size: 18px;
				color: #0084ff;
				cursor: pointer;
			}

			.register {
				font-weight: 500;
				font-size: 18px;
				color: #3a3a3a;
				cursor: pointer;
			}
		}

		.btn {
			width: 100%;
			height: 56px;
			background: #1e40af;
			border-radius: 10px;
			text-align: center;
			line-height: 56px;

			font-weight: 500;
			font-size: 18px;
			color: #ffffff;
			margin-bottom: 25px;

			cursor: pointer;
		}

		.agreement {
			width: 100%;
			font-weight: 500;
			font-size: 18px;
			color: #999999;
			cursor: pointer;
			margin-bottom: 25px;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			width: 410px;
			height: 407px;
			background: #ffffff;
			border-radius: 10px;
			// border: 4px solid #0084ff;
			box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.1);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
				font-size: 0;
				position: relative;

				.qrcode1 {
					width: 208px;
					height: 208px;
				}

				.qrcodeLogo { position: absolute; top: 0; left: 0; right: 0; z-index: 1; width: 90px; height: 90px; border-radius: 50%; margin: 58px auto; }

				.refresh {
					position: absolute;
					left: 0;
					top: 0;

					width: 208px;
					height: 208px;
					background: rgba(0, 0, 0, 0.6);
					border-radius: 10px;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					cursor: pointer;

					i {
						font-size: 50px;
						color: #fff;
						margin-bottom: 20px;
						margin-top: 25px;
					}

					div {
						font-size: 16px;
						color: #fff;

					}
				}
				
				
				.scanSuccessful{
					position: absolute;
					width: 208px;
					height: 208px;
					top: 0;
					left: 0;
					background: rgba(255, 255, 255, 0.96);
					z-index: 11;
					
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					padding-top: 10px;
						img{
							width: 110px;
							height: 110px;
							// margin-bottom: 10px;
						}
					div{
						font-size: 18px;
						color: #353535;
					}
				}

			}


			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 5px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}


	.loginType {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 35px;

		.item {
			position: relative;
			cursor: pointer;

			.item1 {
				font-size: 22px;
				font-weight: 500;
				color: #333333;

			}

			.active {
				font-weight: bold;
			}

			.xian1 {
				position: absolute;
				width: 40px;
				height: 5px;
				border-radius: 5px;
				background: #1b59fa;
				left: 50%;
				transform: translate(-50%);
			}

		}
	}


	.changePassword {
		.elDialogContainer {

			.ipt {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				border: 1px solid #DCDFE6;
				border-radius: 4px;
				padding: 0 15px;

				.text {
					// width: 135px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #343232;
				}

				.el-input {
					flex: 1 !important;
				}

				.el-select {
					flex: 1 !important;
				}

				.el-textarea {
					flex: 1 !important;
				}
			}
		}
	}
</style>
